import { coreExtensionData } from '@backstage/frontend-plugin-api';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { filterPredicateToFilterFunction } from '@backstage/filter-predicates';
import { Route, Routes } from 'react-router-dom';
import { OwnerWorkflowList } from './OwnerWorkflowList';

// Replace only the list. The upstream template wizard retains its form fields,
// validation, secrets and deep links, and all other scaffolder subpages remain.
export const scaffolderTemplatesOverride = scaffolderPlugin
  .getExtension('sub-page:scaffolder/templates')
  .override({
    factory(originalFactory, { config }) {
      const original = originalFactory();
      const configuredGroups = config.groups?.map((group, index) => ({
        id: `configured:${index}`,
        title: group.title,
        filter: filterPredicateToFilterFunction(group.filter),
      }));
      const templateFilter = config.templateFilter
        ? filterPredicateToFilterFunction(config.templateFilter)
        : undefined;

      return [
        ...original,
        coreExtensionData.reactElement(
          <Routes>
            <Route
              index
              element={
                <OwnerWorkflowList
                  configuredGroups={configuredGroups}
                  templateFilter={templateFilter}
                />
              }
            />
            <Route
              path="*"
              element={original.get(coreExtensionData.reactElement)}
            />
          </Routes>,
        ),
      ];
    },
  });
